import allPass from 'lodash/fp/allPass';
import isNull from 'lodash/fp/isNull';
import complement from 'lodash/fp/complement';
import equals from 'lodash/fp/equals';

type PredicateForOrigin = (origin: string | null | undefined) => boolean;

const originIsNotNull: PredicateForOrigin = complement(isNull);

const isNotNullAndEquals: (pattern: 'reseller' | 'non-reseller' | 'other') => PredicateForOrigin = pattern => allPass([originIsNotNull, equals(pattern)]);

const isReseller: PredicateForOrigin = isNotNullAndEquals('reseller');
const isNonReseller: PredicateForOrigin = isNotNullAndEquals('non-reseller');
const isOther: PredicateForOrigin = isNotNullAndEquals('other');

export { isReseller, isNonReseller, isOther };
